import { ControllerEditUx } from './controller-edit-ux.model';
import { ScheduleEditUx } from './schedule-edit-ux.model';
import { ZoneEditUX } from './zone-edit-ux.model';

export class ControllerProgrammability
{
    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            if (json.ControllerEditUx)
            {
                this.ControllerEditUx = new ControllerEditUx(json.ControllerEditUx);
            }

            if (json.ScheduleEditUx)
            {
                this.ScheduleEditUx = new ScheduleEditUx(json.ScheduleEditUx);
            }

            if (json.ZoneEditUx)
            {
                this.ZoneEditUx = new ZoneEditUX(json.ZoneEditUx);
            }
        }
    }

    ControllerEditUx: ControllerEditUx;
    ScheduleEditUx: ScheduleEditUx;
    ZoneEditUx: ZoneEditUX;
}
